import { GiftDeliveryFeePreview } from '@shared/api/giftOrder/giftOrder.interface';

/** 배송 가능 응답만 (판별 유틸의 입력 타입) */
type DeliverablePreview = Extract<GiftDeliveryFeePreview, { deliverable: true }>;

/**
 * "N원 이상 무료배송"이 실제로 적용됐는지 — 기본배송비가 0이고, 규칙이 있고, 소계가 무료 기준 이상.
 * 배송비 요약 줄(GiftDeliveryFeeSummaryRow)과 주소 아래 안내(GiftDeliveryModeSelector)가 같은 판정을 쓴다.
 * (지역 추가배송비는 별도라 total이 0이 아니어도 무료 적용일 수 있다)
 */
export const isFreeBaseFeeApplied = (preview: DeliverablePreview): boolean =>
  preview.baseFee === 0 &&
  !!preview.rule &&
  preview.subtotal >= preview.rule.freeOverAmount;
